class AbstractVerifoneConstantList {
    constructor() {
        this.values = {};
    }

    /**
     * @param {*} values
     */
    setValues(values) {
        this.values = values;
    }

    /**
     * @param {string} name
     *
     * @return {*}
     */
    findByName(name) {
        return this.values[name];
    }

    /**
     * @param {number} id
     *
     * @return {*}
     */
    findNameById(id) {
        return Object.keys(this.values).find((key) => {
            let value = this.values[key];
            return value.id === id;
        });
    }
}

module.exports = AbstractVerifoneConstantList;
